"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _disabledMixin = require("../disabledMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
/** @class LabelMixin */
/** @method */
var LabelMixin = function LabelMixin(props) {
  var size = props.size;
  return (0, _styledToken.default)({
    fontType: "Label.fontTypes." + size,
    optionalColor: 'Label.optionalColor',
    asteriskColor: 'Label.asteriskColor'
  }, function (tokens) {
    return (0, _styledComponents.css)(["&:not([aria-disabled='true']){cursor:pointer;}", " &[data-required=\"true\"]:after{content:'\\00a0*';color:", ";}&[data-optional='true']:after{content:'\\00a0(optional)';color:", ";font-weight:normal;}&[aria-disabled='true']{", "}", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: tokens.fontType
    }, props)), tokens.asteriskColor, tokens.optionalColor, (0, _disabledMixin.disabledMixin)(Object.assign({}, props, {
      disabled: true
    })), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.LabelMixin = LabelMixin;